export const DSN_MOCK = "https://00000000000000000000000000000001@o000000.ingest.sentry.io/0000000";

export const TUNNEL_ENDPOINT_NAME = "sentryTunnel";
